<!-- loading -->
<div class="main-loading" *ngIf="loading">
      <img src="../assets/images/logo-loading.png" alt="">
</div>
<main>
  <!-- header -->
  <app-header *ngIf="currentRouting[1] != 'not-found' && currentRouting[1] != 'server-error'"></app-header>
  <!-- content -->
  <section class="content">
      <router-outlet></router-outlet>
  </section>
  <!-- sub header -->
  <div class="sticky-bottom" *ngIf="currentRouting[1] != 'not-found' && currentRouting[1] != 'server-error'">
      <app-sub-header [dataSub]="subHeader"></app-sub-header>
  </div>
  <!-- footer -->
  <app-footer [dataFooter]="footer"
              [link]="currentRouting[1]"
              *ngIf="currentRouting[1] != 'not-found' && currentRouting[1] != 'server-error'">
  </app-footer>
</main>
